import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AppSettings } from "./../../config/app-settings.js";
import useEvacuationStore from "../../stores/evacuation-store.js";
import ModelMappingDetails from "../details/model-mapping-details.jsx";
import EvacuationPortalDetails from "../details/evacuation-portal-details.jsx";

function SidebarRight() {
  const context = useContext(AppSettings);
  const location = useLocation();
  const [currentContent, setCurrentContent] = useState(null);

  // Component mapping for dynamic content
  const componentMap = {
    "model-mapping-details": ModelMappingDetails,
    "evacuation-portal-details": EvacuationPortalDetails,
  };

  // Route-based component configuration
  const routeComponentConfig = {
    "/evacuation-portal-panels/evacuation-portal/": {
      component: "evacuation-portal-details",
      props: {}, // Component reads from Zustand, no props needed
    },
    "/model-mapping-panels/model-mapping/": {
      component: "model-mapping-details",
      props: {},
    },
  };

  const renderSidebarContent = () => {
    if (!currentContent) {
      return (
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className="row h-100 w-100 py-3 px-2">
            <div className="col-lg-12 p-0 d-flex flex-column justify-content-center">
              <h5 className="mb-3 text-gray-500 text-center">
                <b>No Controls Available</b>
                <span className="ms-2">
                  <i
                    className="fa fa-warning"
                    data-bs-toggle="popover"
                    data-bs-trigger="hover"
                    data-bs-title="Controls Unavailable"
                    data-bs-placement="bottom"
                    data-bs-content="Controls for the current page are not available."
                  ></i>
                </span>
              </h5>
            </div>
          </div>
        </div>
      );
    }

    return currentContent;
  };

  useEffect(() => {
    const pathname = location.pathname;

    // Check if route has configured component
    const config = routeComponentConfig[pathname];

    if (!config) {
      setCurrentContent(null);
      return;
    }

    const Component = componentMap[config.component];
    if (!Component) {
      console.warn(`Component "${config.component}" not found in componentMap`);
      setCurrentContent(null);
      return;
    }

    // Render component
    setCurrentContent(
      <Component key={`${config.component}`} {...config.props} />
    );

    // Cleanup on unmount or route change
    return () => {
      setCurrentContent(null);
    };
  }, [location.pathname]); // Depend on route and store state

  return (
    <AppSettings.Consumer>
      {({ appSidebarTwo, toggleAppSidebarEndMobile }) => (
        <React.Fragment>
          {appSidebarTwo && (
            <React.Fragment>
              <div
                id="sidebar-right"
                className="app-sidebar app-sidebar-end border-start border-secondary"
                data-bs-theme="dark"
              >
                <PerfectScrollbar
                  className="app-sidebar-content h-100"
                  options={{ suppressScrollX: true }}
                >
                  {renderSidebarContent()}
                </PerfectScrollbar>
              </div>

              <div
                className="app-sidebar-bg app-sidebar-end"
                data-bs-theme="dark"
              ></div>

              <div className="app-sidebar-mobile-backdrop app-sidebar-end">
                <Link
                  to="/"
                  onClick={toggleAppSidebarEndMobile}
                  className="stretched-link"
                ></Link>
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </AppSettings.Consumer>
  );
}

export default SidebarRight;
